/**
 * Normalização de texto para BUSCA — nunca para exibição.
 *
 * O que sai daqui serve para comparar o que foi digitado com o que está na
 * tela. Não use para renderizar: "cães" vira "caes", e ninguém quer ler isso.
 */

/**
 * Minúsculas e sem acento.
 *
 * Quem digita "caes" tem de achar **cães**, e quem digita "FELINOS" tem de
 * achar **Felinos**. Numa clínica isso não é conforto: o nome do grupo foi
 * escrito por um colega, com o acento que ele escolheu na hora, e quem procura
 * depois não tem como adivinhar a grafia.
 *
 * ⚠️ `\p{Diacritic}` com a flag `u`, e não a faixa `[\u0300-\u036f]`. A faixa
 * cobre só o bloco combinante básico; a propriedade Unicode cobre todos os
 * diacríticos que o `NFD` separa.
 */
export function achatar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
